import React, { useState } from 'react';

const Dashboard = ({ url }) => {
  if (!url) {
    return null;
  }

  return (
    <div className="dashboard-wrapper">
      <iframe
        src={url}
        frameBorder="0"
        width="100%"
        height="100%"
        allowTransparency
      ></iframe>
    </div>
  );
};

export default Dashboard; 